const view = /*html*/`

    <div id="kt_content_container" class="container-xxl">
        <div class="card bg-transparent shadow-none ">     
            <!--begin::Body-->
            <div class="card-body p-lg-17">
                <!--begin::About-->
                <div class="" data-i18n="[html]site.privacy">
                    <!--begin::Wrapper-->
<div class="mb-10">          
<!--begin::Top-->
<div class="text-center mb-8">
    <!--begin::Title-->
    <h3 class="fs-2hx text-dark mb-5">pDxPLAY Privacy Policy</h3>
    <!--end::Title-->                           
</div>  
<!--end::Top-->                        
</div>
<!--end::Wrapper-->  

<!--begin::Text-->
<div class="fs-5 text-gray-800 fw-semibold mb-4">Last updated: October 15, 2024</div>
<!--end::Text-->

<!--begin::Description-->
<div class="fs-5 fw-semibold text-gray-600">
<section class="mb-8">
    <h2 class="text-success">1. Introduction</h2>
    <p class="ps-5">pDxPLAY (referred to as "we", "our", or "the platform") is committed to protecting the privacy of the information we collect and process. This Privacy Policy details how we collect, use, and protect information related to user accounts, as well as your rights regarding this information. Our data management is carried out in accordance with applicable data protection laws, including the Peruvian Data Protection Law, the European Union's General Data Protection Regulation (GDPR), the California Consumer Privacy Act (CCPA), and data protection regulations in Latin America, such as Brazil's General Data Protection Law (LGPD), and the legislations of Argentina, Colombia, and Mexico.</p>
</section>
<section class="mb-8">
    <h2 class="text-success">2. Information Collected</h2>
    <ul class="ms-5">
        <li>Steam account data: SteamID (SteamID, SteamID64), nickname, avatar, and general location (city/country).</li>
        <li>Game data: Game statistics, match records, performance, and behavior analysis.</li>
        <li>Interaction data: Friend relationships between users, chat messages (global and between friends), server name changes, and account settings.</li>
        <li>Connection information: Anonymized IP addresses (e.g., "123.456.xxx.xxx") and connection logs to game servers.</li>
    </ul>
    <p class="ps-5">pDxPLAY does not access, collect, or request personal data or sensitive information such as names, surnames, IDs, passwords, or email addresses.</p>
</section>
<section class="mb-8">
    <h2 class="text-success">3. Purposes of Processing</h2>
    <p class="ps-5">The information collected is used for the following purposes:</p>
    <ul class="ms-5">
        <li>Providing a competitive and fair gaming environment.</li>
        <li>Providing a personalized and enriching experience on the platform.</li>
        <li>Managing the matchmaking and ranking system.</li>
        <li>Preventing and detecting fraud, cheats, and inappropriate behavior.</li>
        <li>Improving the user experience on the platform.</li>
        <li>Investigating and resolving disputes between users.</li>
        <li>Ensuring platform security and compliance with rules.</li>
        <li>Communicating relevant information and updates about our services.</li>
    </ul>
    <p class="ps-5"><span class="font-italic">Legal basis:</span> The processing of this data is based on the platform's legitimate interest in providing an efficient service and the users' explicit consent, in accordance with the General Data Protection Regulation (GDPR) - Art. 6(1)(f) and the California Consumer Privacy Act (CCPA).</p>
</section>
<section class="mb-8">
    <h2 class="text-success">4. Information Sharing</h2>
    <p class="ps-5">pDxPLAY does not sell or rent the collected information to third parties. However, we may share information with providers who assist in maintaining and technically operating the platform or event organizers that take place within the platform, always for specific, private, and limited purposes. These third parties are required to maintain the confidentiality of the data and strictly follow our instructions to ensure compliance with data protection regulations.</p>
</section>
<section class="mb-8">
    <h2 class="text-success">5. Information Security</h2>
    <p class="ps-5">We implement reasonable security measures to protect the information collected, including encryption and access controls. However, despite our efforts, no method of data transmission over the Internet or electronic storage is 100% secure, so the platform does not guarantee absolute security. This commitment aligns with Article 32 of the GDPR, which requires adequate security measures.</p>
    <p class="ps-5">The use of the platform implies that the data associated with Steam accounts is not verified or considered personal data under data protection regulations.</p>
</section>
<section class="mb-8">
    <h2 class="text-success">6. Information Retention</h2>
    <p class="ps-5">The collected information will be retained only as long as necessary for the purposes for which it was collected. If a user chooses to deactivate their account, the data associated with the account will be deleted or anonymized if necessary within three months. We comply with the retention periods required by Article 5(1)(e) of the GDPR, and in accordance with the provisions of the CCPA and LGPD.</p>
</section>
<section class="mb-8">
    <h2 class="text-success">7. User Rights</h2>
    <p class="ps-5">According to the regulations, users have specific rights regarding the information collected, including:</p>
    <ul class="ms-5">
        <li>Right of access: Request information about the processed data (Article 15 of the GDPR and Section 1798.110 of the CCPA).</li>
        <li>Right to rectification: Correct inaccurate or incomplete information (Article 16 of the GDPR).</li>
        <li>Right to erasure: Request the deletion of information under certain circumstances (Article 17 of the GDPR and Section 1798.105 of the CCPA).</li>
        <li>Right to object: Object to data processing for marketing purposes (Article 21 of the GDPR).</li>
    </ul>                           
</section>
<section>
    <h2 class="text-success">8. Children Mention</h2>
    <p class="ps-5">Our platform is not intended for individuals under thirteen (13) years of age. We do not knowingly collect personal information from minors under that age. If we become aware that we have collected information from a minor, we will take steps to delete that information.</p>
</section>
<section>
    <h2 class="text-success">9. Privacy Policy Updates</h2>
    <p class="ps-5">We reserve the right to modify this Privacy Policy at any time. Changes will be notified through the platform and will take effect immediately, in compliance with Article 12 of the GDPR, which requires transparency in the communication of changes.</p>
</section>
<section class="mb-8">
    <h2 class="text-success">10. Contact</h2>
    <p class="ps-5">If you have questions or concerns about this policy or how your information is handled, do not hesitate to contact us through our main support channel on Discord.</p>
</section>                        
</div>
<!--end::Description-->

                </div>
                <!--end::About-->
            </div>
            <!--end::Body-->
        </div>        
    </div>
					




`;


export default view;